(function ($) {
    var $site = $('.site');
	var $mobileMenu = $('.js-mobile-menu');
    var $toggleMobileMenu = $('.js-toggle-mobile-menu');
	var $siteWrapper = $site.find('#main-content');
	var $focusableElements = $siteWrapper
		.find('a[href], button, input');
	var $focusableElementsFooter = $('.footer-section')
		.find('a[href], button, input');

	$focusableElements.push($focusableElementsFooter);

	//Save all submenuitems.
	var $subMenuItems = $('.sub-menuitems');
	//Save all submenubuttons.
	var $menuButtons = $('.js-submenuitems-button-state');

	//Go thorough all submenuitems and submenubuttons and append -mobile to each id and aria-control.
	if ($subMenuItems && $menuButtons) {
		$subMenuItems.each(function () {
			if ($(this).attr('id') !== undefined && $(this).parents().hasClass('mobile-menu')) {
				$(this).attr('id', $(this).attr('id') + '-mobile');
			}
		});

		$menuButtons.each(function () {
			if ($(this).parents().hasClass('mobile-menu')) {
				$(this).attr('id', $(this).attr('id') + '-mobile');
				$(this).attr('aria-controls', $(this).attr('aria-controls') + '-mobile');
			}

			$(this).hover(function () {
				if ($(this).hasClass('open-sub-menuitems') && !$(this).parents().hasClass('mobile-menu')) {
					$(this).toggleClass('open-sub-menuitems-hover');
					$(this).on('click', function () {
						$(this).toggleClass('open-sub-menuitems-hover');
						$(this).toggleClass('close-sub-menuitems-hover');
					})
				}

				if ($(this).hasClass('close-sub-menuitems') && !$(this).parents().hasClass('mobile-menu')) {
					$(this).toggleClass('close-sub-menuitems-hover');
					$(this).on('click', function () {
						$(this).toggleClass('open-sub-menuitems-hover');
						$(this).toggleClass('close-sub-menuitems-hover');
					})
				}
			})
		});
	}

	$.fn.hasAttr = function (name) {
		return this.attr(name) !== undefined;
	};

	var handleTabIndex = function (removeFocus) {
		if (removeFocus) {
			$focusableElements.each(function (i, focusObject) {
				var $focusObject = $(focusObject);
				$focusObject.attr('tabindex', '-1');
			});
		}
		else {
			$focusableElements.each(function (i, focusObject) {
				var $focusObject = $(focusObject);
				$focusObject.removeAttr('tabindex');
			});
		}
	};

	var toggleMobileMenu = function() {
		$site.toggleClass('site--show-off-canvas');
		$mobileMenu.toggleClass('mobile-menu--is-open');
		$toggleMobileMenu.toggleClass('mobile-menu__button--is-open');
		$('html, body').toggleClass('prevent-scroll');

		var isExpanded = $toggleMobileMenu.attr('aria-expanded');
		isExpanded = (isExpanded === 'true');

		if (isExpanded) {
			$toggleMobileMenu.attr('aria-expanded', false);
		}
		else {
			$toggleMobileMenu.attr('aria-expanded', true);
		}

		if ($siteWrapper.hasAttr('tabindex')) {
			$siteWrapper.removeAttr('tabindex');
			handleTabIndex(false);
		}
		else {
			$siteWrapper.attr('tabindex', '-1');
			handleTabIndex(true);
		}
	};

    $toggleMobileMenu.on('click', toggleMobileMenu);

    $('#search-toggle, #main-content').on('click', function () {
        if ($mobileMenu.hasClass('mobile-menu--is-open')) {
	        toggleMobileMenu();
        }
	});

	var buttonStateClosed = function (currentButton, currentLevel) {
		$(currentButton).removeClass('js-open-sub-menuitems');
		$(currentButton).removeClass('open-sub-menuitems');
		$(currentButton).addClass('js-close-sub-menuitems');
		$(currentButton).addClass('close-sub-menuitems');

		$('nav').find('.level-' + currentLevel).siblings('.js-sub-menuitems').removeClass('open');
		$('nav').find('.level-' + currentLevel).closest('.js-menu-item-expander').removeClass('expanded');

		$(currentButton).closest('.js-menu-item-expander').addClass('expanded');
		$(currentButton).closest('.js-link-wrapper').siblings('.js-sub-menuitems').addClass('open');
		$(currentButton).attr('aria-expanded', 'true');
		$(currentButton).addClass('expanded');
		$(currentButton).children('span').text($(this).children('span').attr('data-button-close-translation'));
	}
	var buttonStateOpen = function (currentButton) {
		$(currentButton).removeClass('js-close-sub-menuitems');
		$(currentButton).removeClass('close-sub-menuitems');
		$(currentButton).addClass('js-open-sub-menuitems');
		$(currentButton).addClass('open-sub-menuitems');

		$(currentButton).closest('.js-menu-item-expander').removeClass('expanded');
		$(currentButton).removeClass('expanded');
		$(currentButton).closest('.js-link-wrapper').siblings('.js-sub-menuitems').removeClass('open');
		$(currentButton).attr('aria-expanded', 'false');
		$(currentButton).children('span').text($(currentButton).children('span').attr('data-button-open-translation'));
	}
	var resetButtonStates = function (currentButton, currentLevel) {
		$menuButtons.each(function (index, menuButton) {
			if (currentButton.attr('id') !== $(menuButton).attr('id') && currentLevel === $(menuButton).data('level')) {
				buttonStateOpen($(menuButton), currentLevel);
			}
		})
	}

	var toggleButtonState = function (event) {
		var currentLevel = $(event.target).data('level');
		if ($(event.target).hasClass('js-open-sub-menuitems') === true) {
			buttonStateClosed($(event.target),currentLevel);
		} else {
			buttonStateOpen($(event.target), currentLevel);
		}

		resetButtonStates($(event.target), currentLevel);
	}

	$('.js-submenuitems-button-state').on('click', toggleButtonState);
})(jQuery);
